(function ($) {
    $('a.country').click(function (e) {
        e.preventDefault();
        var target = $(e.target);
        $("html, body").animate({scrollTop: $(target ).offset().top - 60}, 800);
        return false;
    });

})(jQuery);